/**
 * @fileoverview > handler for the "/apps/:app_group_id/email/draganddrop_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdEmailDraganddropSettingsCacheKeys } from "./constants";
import type { PostDragAndDropEditorSettingsProps, PostDragAndDropEditorSettingsResult } from "./types";

export const postDragAndDropEditorSettings = reactQueryMutationAdapter(
  appsAppGroupIdEmailDraganddropSettingsCacheKeys,
  ({ appGroupId, ...props }: PostDragAndDropEditorSettingsProps): Promise<PostDragAndDropEditorSettingsResult> => {
    return fetch(`/apps/${appGroupId}/email/draganddrop_settings`, "POST", props);
  }
);
